export const addArrFilter = (obj, arry) => {
  if (obj !== "") {
    arry.push(obj);
  }
};